import { map } from 'rxjs/operators';
import { DataManagerService } from '../../../../../data/services/DataManager/data-manager.service';
import { AppConstants } from '../../../../../shared/constants/app-constants';
import { TopbarSearchResult } from '../../topbar-search.model';
import { SearchProvider } from '../record-search.model';
import { formatFilterDate, formatUsd, joinParts, listSearch, REDSHIFT_PARAMS, REDSHIFT_TIMEOUT_MS } from './list-search';

/** How far back the search looks; /cases rejects (422) a request without a date range. */
export const DISPUTE_SEARCH_MONTHS = 12;

/**
 * Disputes — GET /cases (DisputesComponent's list endpoint; /disputes is the accept-dispute call),
 * searched in Redshift (src=R).
 * /cases requires a report_date / transaction_date / last_updated_date range; like the Disputes
 * page we filter on report_date, but over the last DISPUTE_SEARCH_MONTHS months instead of the
 * current month.
 * case_amount is already in dollars (the list renders it without /100) and is shown negative, as the
 * Disputes list does ('-' + amount). card_number is never shown (PCI).
 * Opens /disputes/dispute-details?id=<case id>, as the list does.
 */
export function disputesProvider(dataManager: DataManagerService, now: () => Date = () => new Date()): SearchProvider {
  return {
    group: 'Disputes',
    parent: 'disputes',
    accepts: () => true,
    search: query => listSearch(dataManager, AppConstants.SERVICE_NAME_CASES, query,
      { ...reportDateRange(now()), ...REDSHIFT_PARAMS }, REDSHIFT_TIMEOUT_MS).pipe(
      map(rows => rows.map(toResult).filter(Boolean))
    )
  };
}

function reportDateRange(today: Date): Record<string, string> {
  const from = new Date(today.getFullYear(), today.getMonth() - DISPUTE_SEARCH_MONTHS, today.getDate());
  return {
    'report_date[gte]': formatFilterDate(from),
    'report_date[lte]': formatFilterDate(today)
  };
}

function toResult(row: any): TopbarSearchResult {
  if (!row?.id) {
    return null;
  }
  const amount = Number(row.case_amount) ? formatUsd(Math.abs(Number(row.case_amount))) : '';
  return {
    group: 'Disputes',
    label: joinParts('Case ' + (row.case_number || row.id), amount && '-' + amount),
    sublabel: joinParts(row.status, row.reason_desc),
    route: ['/disputes/dispute-details'],
    queryParams: { id: row.id }
  };
}
